"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/function-component-definition */
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("~/store/selectors");
const BOM_1 = __importDefault(require("./BOM"));
const CatalogWidget_1 = __importDefault(require("./CatalogWidget"));
const ItemPropertiesWidget_1 = __importDefault(require("./ItemPropertiesWidget"));
const RecommendedFastenersWidget_1 = __importDefault(require("./RecommendedFastenersWidget"));
const QuoteWidget_1 = __importDefault(require("./QuoteWidget"));
const DefaultFastenerWidget_1 = __importDefault(require("./DefaultFastenerWidget"));
const ShortcutsWidget_1 = __importDefault(require("./ShortcutsWidget"));
const PreconfiguredFramesWidget_1 = __importDefault(require("./PreconfiguredFramesWidget"));
const ItemReplacementWidget_1 = __importDefault(require("./ItemReplacementWidget"));
const WidgetsManager_scss_1 = __importDefault(require("./WidgetsManager.scss"));
const CurrentFastenerWidget_1 = __importDefault(require("./CurrentFastenerWidget"));
const AiChatWidget_1 = __importDefault(require("./AiChatWidget/AiChatWidget"));
const WidgetsManager = ({ toggleWidgets }) => {
    const isQuoteShown = (0, react_redux_1.useSelector)(selectors_1.selectQuoteShown);
    const isAiCopilotEnabled = (0, react_redux_1.useSelector)(selectors_1.selectIsAiCopilotEnabled);
    return (react_1.default.createElement("div", { className: WidgetsManager_scss_1.default.widgetsBoundaries },
        isQuoteShown ? react_1.default.createElement(QuoteWidget_1.default, null) : react_1.default.createElement(BOM_1.default, null),
        react_1.default.createElement(CatalogWidget_1.default, null),
        isAiCopilotEnabled && react_1.default.createElement(AiChatWidget_1.default, null),
        react_1.default.createElement(ItemPropertiesWidget_1.default, null),
        react_1.default.createElement(RecommendedFastenersWidget_1.default, { toggleWidgets: toggleWidgets }),
        react_1.default.createElement(DefaultFastenerWidget_1.default, null),
        react_1.default.createElement(CurrentFastenerWidget_1.default, null),
        react_1.default.createElement(ShortcutsWidget_1.default, null),
        react_1.default.createElement(PreconfiguredFramesWidget_1.default, null),
        react_1.default.createElement(ItemReplacementWidget_1.default, null)));
};
exports.default = WidgetsManager;
